import React from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import './index.scss';
import { store } from './features/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import theme from './theme';
import { EnhancedStore } from '@reduxjs/toolkit';
import App from './App';
import { SnackbarProvider } from 'notistack';

type RootProps = { store: EnhancedStore };
const Root = ({ store }: RootProps) => (
  <Provider store={store}>
    <SnackbarProvider maxSnack={1}>
      <App />
    </SnackbarProvider>
  </Provider>
);

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Root store={store} />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
